import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Api } from '../core/api';
import { isNullOrUndefined } from 'util';

@Injectable()
export class DashboardGuard implements CanActivate {
  constructor(private api: Api,
              private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = this.api.fetchToken();
    if (isNullOrUndefined(token)) {
      this.router.navigate(['login']);
    }
    return !isNullOrUndefined(token);
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/guards/dashboard.guard.ts